import ToggleButton from "@Generic/buttons/ToggleButton";
import React from "react";
import {useTranslation} from "@Translation/hooks/useTranslation";
import {useAccommodationToggle} from "@Form/features/accommodation/hooks/useAccommodationToggle";

export const AccommodationToggle = () => {
    const {
        accommodationRedirect,
        toggleAccommodationRedirect,
    } = useAccommodationToggle();

    return (
        <ToggleButton
            label={useTranslation('form.accommodation')}
            additionalWrapperClassName="gb--search-accommodation"
            slim
            checked={accommodationRedirect}
            onClick={toggleAccommodationRedirect}
        />
    );
}